import { Link } from "@/components/clickable";
import { getProjectPath } from "@/modules/get-path";
import { ProjectStatusCell } from "./project-status-cell";

const PROJECTS_TABLE_COLUMNS = [
  {
    field: "name",
    headerName: "Name",
    flex: 2,
    minWidth: 150,
    checkboxSelection: true,
    headerCheckboxSelection: true,
    cellRenderer: (params) => (
      <Link className="flex w-full" href={getProjectPath(params.data.slug)}>
        {params.value}
      </Link>
    ),
  },
  {
    field: "createdAt",
    headerName: "Creation date",
    valueFormatter: (params) => new Date(params.value).toLocaleDateString(),
    minWidth: 120,
  },
  {
    field: "statementsMetadata.numberOfPages",
    headerName: "# of pages",
    flex: 0.5,
    minWidth: 100,
  },
  {
    field: "status",
    headerName: "Status",
    cellRenderer: (params) => <ProjectStatusCell status={params.value} />,
    flex: 0.8,
    minWidth: 120,
  },
];

export default PROJECTS_TABLE_COLUMNS;
